import React from "react";
import SuperSelect from "../../Misc/SuperSelect";
import EssenceReferenceShipEdit from "../../Essence/EssenceReferenceShipEdit";

export default class MaintShipSelect extends React.Component {
  render() {
    return (
      <>
        <SuperSelect
          grey
          defaultValue={this.props.shipId}
          onChange={(value) => this.props.onChange(value)}
          onSingleItem={(item) => this.props.onChange(item.value)}
          essence="ship"
          placeholder="Выберите судно..."
          nameField="name"
          idField="id"
          reference={{
            title: "Суда",
            essence: "ship",
            showDescription: true,
            showType: true,
            itemEditor: (itemEditorProps) => (
              <EssenceReferenceShipEdit {...itemEditorProps} />
            ),
          }}
        />
      </>
    );
  }
}
